// JavaScript
function slider() {
  [...document.querySelectorAll('.slider-wrapper-cooperation')]?.forEach(wrapper => {
    let autoplayDisabledByVideo = false;
    let mainInstance;
    let thumbsInstance;

    const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed) || 1000;
    const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed) || 1000;

    const mainEl =
      wrapper.querySelector('#main-carousel, .splide--main, .splide.main') ||
      wrapper.querySelector('.splide');

    const thumbsEl = wrapper.querySelector('#thumbnail-carousel, .splide--thumbs, .splide.thumbnails');

    const initSlider = () => {
      const isMobile = window.innerWidth < 1024;

      if (mainInstance) {
        mainInstance.destroy();
        mainInstance = undefined;
      }
      if (thumbsInstance) {
        thumbsInstance.destroy();
        thumbsInstance = undefined;
      }

      if (!mainEl) return;

      // Inject play overlay buttons for slides that have video/embed in the main slider
      (function injectCustomVideoPlay() {
        const slides = mainEl.querySelectorAll('.splide__slide');
        slides.forEach(slide => {
          const hasNativeVideoBlock = !!slide.querySelector('.wp-block-video');
          const hasEmbedWrapper = !!slide.querySelector('.wp-block-embed__wrapper');
          if (!(hasNativeVideoBlock || hasEmbedWrapper)) return;

          // Prefer to attach the button to the block container
          const host = slide.querySelector('.wp-block-video, .wp-block-embed.is-type-video') || slide;
          let btn = host.querySelector('.custom-video-play');
          if (!btn) {
            btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'custom-video-play';
            host.appendChild(btn);
          }

          // Inline play handler (no modal)
          if (!btn._boundInlinePlay) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              const videoEl = slide.querySelector('.wp-block-video video');
              const iframe = slide.querySelector('.wp-block-embed.is-type-video iframe');

              // Pause and permanently disable slider autoplay after user starts video (all viewports)
              try {
                if (mainInstance && typeof mainInstance.pause === 'function') mainInstance.pause();
                if (mainInstance && typeof mainInstance.options === 'function') mainInstance.options({ autoplay: false });
                // Try to pause internal Autoplay component as well
                if (mainInstance && mainInstance.Components && mainInstance.Components.Autoplay && typeof mainInstance.Components.Autoplay.pause === 'function') {
                  mainInstance.Components.Autoplay.pause();
                }
                autoplayDisabledByVideo = true;
                if (mainEl && mainEl.classList) {
                  mainEl.classList.add('autoplay-paused');
                }
              } catch (err) {}

              if (videoEl) {
                videoEl.setAttribute('playsinline', '');
                videoEl.setAttribute('controls', '');
                try { videoEl.play(); } catch (err) {}
                // Hide the overlay after starting playback
                btn.style.display = 'none';
                // Mark container as playing so styles can control overlay
                host.classList.add('playing');

                // Resume slider when video ends/pauses (only if autoplay wasn't disabled by a video start)
                const resume = () => { try { if (!autoplayDisabledByVideo && mainInstance && typeof mainInstance.play === 'function') mainInstance.play(); } catch (err) {} };
                videoEl.addEventListener('ended', function onEnded(){
                  host.classList.remove('playing');
                  btn.style.display = '';
                  resume();
                }, { once: true });
                videoEl.addEventListener('pause', function onPause(){
                  // If user paused manually, allow slider to resume
                  host.classList.remove('playing');
                  btn.style.display = '';
                  resume();
                  videoEl.removeEventListener('pause', onPause);
                });
              } else if (iframe) {
                // Facade embeds (see Theme::cooperation_slider_youtube_facade) keep the URL in data-src
                const baseSrc = iframe.dataset.src || iframe.src;
                // Remember original src once to restore on slide change
                if (!iframe.dataset.originalSrc && baseSrc) {
                  iframe.dataset.originalSrc = baseSrc;
                }
                const isYouTube = /youtube\.com|youtu\.be|youtube-nocookie\.com/.test(baseSrc || '');
                try {
                  const url = new URL(baseSrc, window.location.origin);
                  url.searchParams.set('autoplay', '1');
                  url.searchParams.set('muted', '1');
                  if (isYouTube) {
                    url.searchParams.set('enablejsapi', '1');
                    // origin is recommended for YT API events
                    if (!url.searchParams.get('origin')) {
                      url.searchParams.set('origin', window.location.origin);
                    }
                  }
                  iframe.src = url.toString();
                } catch (err) {
                  // Fallback string ops
                  let sep = baseSrc.indexOf('?') === -1 ? '?' : '&';
                  iframe.src = baseSrc + sep + 'autoplay=1&muted=1' + (isYouTube ? '&enablejsapi=1&origin=' + encodeURIComponent(window.location.origin) : '');
                }
                host.classList.add('video-loaded');
                const allow = iframe.getAttribute('allow') || '';
                if (!/autoplay/.test(allow)) iframe.setAttribute('allow', (allow + '; autoplay').trim());
                btn.style.display = 'none';
                // Mark container as playing so styles can control overlay
                host.classList.add('playing');

                // If YouTube, bind API to detect pause/ended and toggle class/overlay
                if (isYouTube) {
                  const ensureYTReady = (cb) => {
                    if (window.YT && window.YT.Player) return cb();
                    window._ytReadyCallbacks = window._ytReadyCallbacks || [];
                    window._ytReadyCallbacks.push(cb);
                    if (!window._ytApiLoading) {
                      window._ytApiLoading = true;
                      const tag = document.createElement('script');
                      tag.src = 'https://www.youtube.com/iframe_api';
                      document.head.appendChild(tag);
                      const prev = window.onYouTubeIframeAPIReady;
                      window.onYouTubeIframeAPIReady = function() {
                        if (typeof prev === 'function') prev();
                        (window._ytReadyCallbacks || []).forEach(fn => { try { fn(); } catch(e) {} });
                        window._ytReadyCallbacks = [];
                      };
                    }
                  };
                  ensureYTReady(() => {
                    if (!iframe._ytPlayer) {
                      try {
                        iframe._ytPlayer = new window.YT.Player(iframe, {
                          events: {
                            onStateChange: function(ev){
                              if (!window.YT || !window.YT.PlayerState) return;
                              const st = ev.data;
                              if (st === window.YT.PlayerState.PAUSED || st === window.YT.PlayerState.ENDED) {
                                host.classList.remove('playing');
                                btn.style.display = '';
                              } else if (st === window.YT.PlayerState.PLAYING) {
                                host.classList.add('playing');
                                btn.style.display = 'none';
                              }
                            }
                          }
                        });
                      } catch(e) { /* noop */ }
                    }
                  });
                }

                // Attempt to detect end via slide move; resume slider autoplay only if not disabled by video start
                if (mainInstance) {
                  mainInstance.on('move', function () {
                    try { if (!autoplayDisabledByVideo && mainInstance && typeof mainInstance.play === 'function') mainInstance.play(); } catch (err) {}
                  });
                }
              }
            }, { passive: false });
            btn._boundInlinePlay = true;
          }
        });
      })();

      if (thumbsEl) {
        // Validate structure and number of slides
        const mainSlides = mainEl.querySelectorAll('.splide__list > .splide__slide').length;
        const thumbSlides = thumbsEl.querySelectorAll('.splide__list > .splide__slide').length;

        if (!mainEl.querySelector('.splide__track') || !thumbsEl.querySelector('.splide__track')) {
          console.error('[Splide] Brak .splide__track w jednym z elementów (main/thumbs).');
          return;
        }
        if (!mainSlides || !thumbSlides) {
          console.error('[Splide] Brak slajdów w jednym z elementów (main/thumbs).');
          return;
        }
        if (mainSlides !== thumbSlides) {
          console.error(`[Splide] Niezgodna liczba slajdów: main=${mainSlides}, thumbs=${thumbSlides}. Sync przerwany.`);
          return;
        }

        thumbsInstance = new Splide(thumbsEl, {
          gap: 50,
          type: isMobile ? 'fade' : 'loop',
          speed: isMobile ? mobileSpeed : desktopSpeed,
          rewind: true,
          perPage: 1,
          perMove: 1,
          pagination: false,
          isNavigation: true,
          arrows: false,
          autoWidth: true,
        });

        mainInstance = new Splide(mainEl, {
          type: 'fade',
          speed: isMobile ? mobileSpeed : desktopSpeed,
          perPage: 1,
          perMove: 1,
          gap: '1.5rem',
          autoHeight: true,
          lazyload: 'sequential',
          rewind: true,
          mediaQuery: 'min',
          pagination: true,
          arrows: true,
          autoplay: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          interval: 7000,
          focusableNodes: true,
          easing: isMobile ? 'linear' : 'cubic-bezier(0.25, 1, 0.5, 1)',
          breakpoints: {
            1024: {
              pagination: false,
              autoplay: false,
            },
          },
        });

        // First, register sync...
        mainInstance.sync(thumbsInstance);
        // ...then mount in the order recommended by Splide
        mainInstance.mount();
        thumbsInstance.mount();

        // Your fade-out effect + pause any playing media when slide changes
        mainInstance.on('move', function (newIndex, prevIndex, destIndex) {
          const slides = mainEl.querySelectorAll('.splide__slide');

          // Fade-out handling
          slides.forEach(function (slide, index) {
            if (index < destIndex) slide.classList.add('fade-out');
            else slide.classList.remove('fade-out');
          });

          // Pause media on the previous and any non-active slides
          const pauseSlide = (slide) => {
            if (!slide) return;
            const videoEl = slide.querySelector('.wp-block-video video');
            const iframe = slide.querySelector('.wp-block-embed.is-type-video iframe');
            const host = slide.querySelector('.wp-block-video, .wp-block-embed.is-type-video') || slide;
            const btn = host.querySelector('.custom-video-play');

            if (videoEl) {
              try { videoEl.pause(); } catch (e) {}
              // Show overlay again
              if (btn) btn.style.display = '';
            }

            // Only touch embeds that were started - assigning src reloads the iframe,
            // and this runs for every non-active slide on each autoplay step.
            if (iframe && host.classList.contains('video-loaded')) {
              if (iframe.dataset.src) {
                // Facade: unload the player and bring the thumbnail back
                iframe.src = 'about:blank';
              } else if (iframe.dataset.originalSrc) {
                // Restore original src (removes autoplay)
                iframe.src = iframe.dataset.originalSrc;
              }
              host.classList.remove('video-loaded');
              // Show overlay again
              if (btn) btn.style.display = '';
            }
            // Remove playing state class
            if (host) host.classList.remove('playing');
          };

          // Pause previous slide if index provided
          if (typeof prevIndex === 'number') {
            const prevSlide = slides[prevIndex];
            pauseSlide(prevSlide);
          }

          // Also pause any other non-active slides, just in case
          slides.forEach((slide, i) => {
            if (i !== destIndex) pauseSlide(slide);
          });

          // Always remove the autoplay-paused class after any slide change
          try { if (mainEl && mainEl.classList) mainEl.classList.remove('autoplay-paused'); } catch (e) {}

          // Restore autoplay on mobile after slide has changed if it was disabled by video
          try {
            if (window.innerWidth < 1024 && autoplayDisabledByVideo) {
              if (typeof mainInstance.options === 'function') mainInstance.options({ autoplay: true });
              if (mainInstance.Components && mainInstance.Components.Autoplay && typeof mainInstance.Components.Autoplay.play === 'function') {
                mainInstance.Components.Autoplay.play();
              }
              if (typeof mainInstance.play === 'function') mainInstance.play();
              autoplayDisabledByVideo = false;
            }
          } catch (e) {}
        });
      }
    };

    initSlider();
    window.addEventListener('resize', initSlider);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  slider();
});
